import { api } from "@/api/client";

/* Phase 27 · Slice A — Audit-Ready Compliance Engine.
   Builds a tax_ledger_manifest into the Vault, then exports it as a
   B2B-stamped PDF/CSV asset. Downloads stream through the tenant-scoped
   vault-file endpoint (authenticated blob — never a raw URL). */
export const complianceApi = {
  buildManifest: () => api.post("/compliance/manifest").then((r) => r.data),
  listManifests: () => api.get("/compliance/manifests").then((r) => r.data),
  export: (asset_id, format) =>
    api.post("/compliance/export", { asset_id, format }).then((r) => r.data),
};

// Fetch a vault export asset as an authenticated blob and trigger a download.
export async function downloadVaultAsset(assetId, filename) {
  const res = await api.get(`/central-core/vault-file/${assetId}?download=1`, {
    responseType: "blob",
  });
  const url = URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename || "compliance-report";
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
